import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  name: 'step-progress-bar',
})

export default class StepProgressBar extends Vue {

  @Prop()
  private fillLevel!: string;

  @Prop()
  private preference!: {name: string, value: number};

  get fillPercentage() {
    return +this.fillLevel * 100;
  }
  get connectors() {
    const connectors = [];
    for (let connectingPos = 0; connectingPos <= 10; connectingPos++) {
      connectors[connectingPos] = connectingPos * 10 - 1.5;
    }
    connectors[0] = 0;
    return connectors;
  }


  // ----------------------------------------------------------
  // Action

  private onSelectPoint(positionIndex: number) {
  const updatedPosition = positionIndex * 0.10;
  this.$set(this.preference, 'value', updatedPosition.toFixed(2));
  // this.$emit('onSelectPoint', updatedPosition);
  }
}
